























































































import {Component, Vue} from 'vue-property-decorator';
import {AxiosStatic} from "axios";
import LoginGoogleButton from '@/components/LoginGoogleButton.vue';

@Component({
	components: {
		LoginGoogleButton
	}
})
export default class LoginPanel extends Vue {
	public $http!: AxiosStatic;
	public email: string = '';
	public password: string = '';
	public remember: boolean = false;
	public loginError: boolean = false;
	public loginLoading: boolean = false;

	public login() {
		this.loginError = false;
		this.loginLoading = true;
		let url = '/public/authenticate';
		this.$http.post(url, {'email': this.email, 'password': this.password, 'remember': this.remember})
			.then(() => this.$http.get('/private/currentuser').then((response) => {
				this.$store.commit('SET_LOGGEDIN', true);
				this.$store.commit('SET_USER', response.data);
				this.$store.dispatch('loadOrganisation', {root: true});
				this.loginLoading = false;
				if (this.$route.path != '/dashboard') {
					this.$router.push('/dashboard');
				}
			}))
			.catch(() => {
				this.loginLoading = false;
				this.loginError = true;
			})
	}
}
